<div class="setup-wrapper">
<img class="logo" src="../../../assets/svg/FieldEx_Logo_Black_NoBorder.svg" alt="FieldEx Logo" *ngIf="packageCode !='Coffee_Pro'"/>
<img class="logo" src="../../../assets/svg/moqa/black-fieldex.svg" alt="FieldEx Logo" *ngIf="packageCode =='Coffee_Pro'"/>

 <div class="setup-left">

    <div class="form-section">
      <h2>Set your password</h2>
      <p class="subtitle">Secure your account with a strong password.</p>

      <form (ngSubmit)="activateAccount()" [formGroup]="accountForm">
        <div class="form-field">
            <label for="password">Password</label>
            <div class="input-wrapper">
                <i class="fa-solid fa-lock icon"></i>
                   <input
                    pInputText
                    [(ngModel)]="profile.password"
                    id="input_PwdActivateNewPwdField"
                    autocomplete="new-password"
                    [type]="fieldTextType ? 'text' : 'password'"
                    formControlName="password"
                    name="password"
                    (input)="getPassowrdLength($event)" 
                    placeholder="Enter your password"
                    />

                    <i [ngClass]="fieldTextType ? 'fa-solid fa-eye' : 'fa-solid fa-eye-slash'"  (click)="fieldTextType = !fieldTextType" class="eye-toggle"></i>
            </div>
            <div *ngIf="accountForm.controls['password'].dirty && accountForm.controls['password'].invalid">
                <span  class="p-error text-10" id="label_PwdActivateNewPwdReqField" *ngIf="accountForm.controls['password'].errors?.required">This field is required</span>
            </div>
            
            <div class="pwd-valid" *ngIf="showtooltip || isPasswordHasUserName">
                                <div class="pwd-valid-body">
                                    <div class="pb-1">
                                        <span>{{langData.resetPassword.messages.passwordRequirement}}&colon;</span>
                                    </div>
                                    <div class="flex-align-center pb-1">
                                        <span class="w-12px lh-1">
                                            <i class="fa-regular fa-check text-success" *ngIf="passwordFormField?.value?.match('^(?=.*[A-Z])')"></i>
                                            <i class="fa-regular fa-xmark p-error" *ngIf="!passwordFormField?.value?.match('^(?=.*[A-Z])')"></i>
                                        </span>
                                        <span class="ms-2"[ngClass]="passwordFormField?.value?.match('^(?=.*[A-Z])') ? 'text-success':''">{{langData.resetPassword.messages.oneUppercase}}</span>
                                    </div>
                                    <div class="flex-align-center pb-1">
                                        <span class="w-12px lh-1">
                                            <i class="fa-regular fa-check text-success" *ngIf="passwordFormField?.value?.match('^(?=.*[a-z])')"></i>
                                            <i class="fa-regular fa-xmark p-error" *ngIf="!passwordFormField?.value?.match('^(?=.*[a-z])')"></i>
                                        </span>
                                        <span class="ms-2" [ngClass]="passwordFormField?.value?.match('^(?=.*[a-z])') ? 'text-success':''">{{langData.resetPassword.messages.oneLowercase}}</span>
                                    </div>
                                    <div class="flex-align-center pb-1">
                                        <span class="w-12px lh-1">
                                            <i class="fa-regular fa-check text-success" *ngIf="passwordFormField?.value?.match('(.*[0-9].*)')"></i>
                                            <i class="fa-regular fa-xmark p-error" *ngIf="!passwordFormField?.value?.match('(.*[0-9].*)')"></i>
                                        </span>
                                        <span class="ms-2" [ngClass]="passwordFormField?.value?.match('(.*[0-9].*)') ? 'text-success':''">{{langData.resetPassword.messages.oneNumeric}}</span>
                                    </div>
                                    <div class="flex-align-center pb-1">
                                        <span class="w-12px lh-1">
                                            <i class="fa-regular fa-check text-success" *ngIf="passwordFormField?.value?.match('(?=.*[!@#$%^&*])')"></i>
                                            <i class="fa-regular fa-xmark p-error" *ngIf="!passwordFormField?.value?.match('(?=.*[!@#$%^&*])')"></i>
                                        </span>
                                        <span class="ms-2" [ngClass]="passwordFormField?.value?.match('(?=.*[!@#$%^&*])') ? 'text-success':''">{{langData.resetPassword.messages.oneSymbol}}</span>
                                    </div>
                                    <div class="flex-align-center pb-1">
                                        <span class="w-12px lh-1">
                                            <i class="fa-regular fa-check text-success" *ngIf="passwordFormField?.value?.match('.{8,}')"></i>
                                            <i class="fa-regular fa-xmark p-error" *ngIf="!passwordFormField?.value?.match('.{8,}')"></i>
                                        </span>
                                        <span class="ms-2"  [ngClass]="passwordFormField?.value?.match('.{8,}') ? 'text-success':''">{{langData.resetPassword.messages.minimumChars}}</span>
                                    </div>
                                    <!-- <div class="flex-align-center" >
                                        <span class="w-12px lh-1">
                                            <i class="fa-regular fa-check text-success" *ngIf="!isPasswordHasUserName"></i>
                                            <i class="fa-regular fa-xmark p-error" *ngIf="isPasswordHasUserName"></i>
                                        </span>
                                        <span class="ms-2" [ngClass]="!isPasswordHasUserName}">{{langData.resetPassword.messages.usernameExclusion}}</span>
                                    </div> -->
                                </div>
                             </div>

        </div>

        <div class="form-field">
            <label for="password">Confirm Password</label>
            <div class="input-wrapper">
                <i class="fa-solid fa-lock icon"></i>
                    <input pInputText [(ngModel)]="profile.cPassword" id="input_PwdActivateRetypePwdField" autocomplete="new-password" [type]="fieldTextType2 ? 'text' : 'password'" (input)="getCPassowrdLength($event)" formControlName="cPassword" name="cPassword" 
                    placeholder="Re-enter your password">
                    <i class="fa-solid"
                    [ngClass]="fieldTextType2 ? 'fa-solid fa-eye' : 'fa-solid fa-eye-slash'"
                    (click)="fieldTextType2 = !fieldTextType2"
                    class="eye-toggle"></i>
            </div>
             <div *ngIf="!isPasswordMatching && profile.cPassword.length > 0">
                <span class="p-error text-10" id="label_PwdActivateRetypePwdReqField">{{langData.resetPassword.validationFE.passwordsDoNotMatch}}</span>
            </div>
        </div>

        <button type="submit">Proceed</button>
      </form>
    </div>
  </div>

  <div class="setup-right">
    
    <div class="img-wrapper-lock">
   <svg xmlns="http://www.w3.org/2000/svg" width="260" height="260" fill="none" viewBox="0 0 260 260">
        <path fill="#000" d="M0 0h260v260H0z"/>
        <rect width="190" height="144" x="35" y="102" fill="url(#a)" stroke="url(#b)" stroke-width="8" rx="26"/>
        <g filter="url(#c)">
            <path fill="url(#d)" d="M60 54v66a8 8 0 0 0 8 8h4a8 8 0 0 0 8-8V56c0-12.15 9.85-22 22-22h56c12.15 0 22 9.85 22 22v64a8 8 0 0 0 8 8h4a8 8 0 0 0 8-8V54c0-22.091-17.909-40-40-40h-60c-22.091 0-40 17.909-40 40Z" shape-rendering="crispEdges"/>
            <path stroke="url(#e)" stroke-linecap="round" stroke-linejoin="round" stroke-width="8" d="M60 54v66a8 8 0 0 0 8 8h4a8 8 0 0 0 8-8V56c0-12.15 9.85-22 22-22h56c12.15 0 22 9.85 22 22v64a8 8 0 0 0 8 8h4a8 8 0 0 0 8-8V54c0-22.091-17.909-40-40-40h-60c-22.091 0-40 17.909-40 40Z" shape-rendering="crispEdges"/>
        </g>
        <g filter="url(#f)">
            <path stroke="url(#g)" stroke-width="8" d="m140.691 180.873 6.611 27.173c.8 3.292-1.324 5.954-4.744 5.954h-25.116c-3.373 0-5.544-2.666-4.744-5.954l6.611-27.173C110.85 176.927 105 168.444 105 158.615 105 145.021 116.193 134 130 134s25 11.021 25 24.615c0 9.829-5.85 18.312-14.309 22.258Z" clip-rule="evenodd" shape-rendering="crispEdges"/>
        </g>
        <defs>
            <linearGradient id="b" x1="130" x2="130" y1="102" y2="246" gradientUnits="userSpaceOnUse">
            <stop stop-color="#212375"/>
            <stop offset=".795" stop-color="#6366F1"/>
            <stop offset="1" stop-color="#9093FF"/>
            </linearGradient>
            <linearGradient id="d" x1="130" x2="130" y1="14" y2="128" gradientUnits="userSpaceOnUse">
            <stop/>
            <stop offset="1" stop-color="#252661" stop-opacity=".3"/>
            </linearGradient>
            <linearGradient id="e" x1="200" x2="60" y1="14" y2="128" gradientUnits="userSpaceOnUse">
            <stop stop-color="#B7B9FF"/>
            <stop offset=".505" stop-color="#6366F1"/>
            <stop offset="1" stop-color="#3538B3" stop-opacity=".8"/>
            </linearGradient>
            <linearGradient id="g" x1="130" x2="130" y1="134" y2="214" gradientUnits="userSpaceOnUse">
            <stop stop-color="#D5D6FF"/>
            <stop offset=".2" stop-color="#B8BAFF"/>
            <stop offset="1" stop-color="#6366F1"/>
            </linearGradient>
            <filter id="c" width="172" height="146" x="44" y="2" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
            <feOffset dy="4"/>
            <feGaussianBlur stdDeviation="6"/>
            <feComposite in2="hardAlpha" operator="out"/>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_152_3382"/>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow_152_3382" result="shape"/>
            </filter>
            <filter id="f" width="82" height="112" x="89" y="122" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
            <feOffset dy="4"/>
            <feGaussianBlur stdDeviation="6"/>
            <feComposite in2="hardAlpha" operator="out"/>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_152_3382"/>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow_152_3382" result="shape"/>
            </filter>
            <radialGradient id="a" cx="0" cy="0" r="1" gradientTransform="matrix(0 144 -190 0 130 102)" gradientUnits="userSpaceOnUse">
            <stop stop-color="#3D42C2"/>
            <stop offset="1"/>
            </radialGradient>
        </defs>
        </svg>
    </div>

  </div>
</div>
